module.exports = __webpack_public_path__ + "img/PICK_UP.b312f686.svg";